import React from 'react';
import { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
    icon?: LucideIcon;
    title: string;
    description?: string;
}

export function EmptyState({ icon: Icon, title, description }: EmptyStateProps) {
    return (
        <div className="text-center py-12 text-muted-foreground glass-strong rounded-xl border border-primary/30">
            {Icon && (
                <div className="flex justify-center mb-4">
                    <div className="p-4 rounded-full bg-primary/5 border border-primary/20">
                        <Icon className="w-8 h-8 text-primary" />
                    </div>
                </div>
            )}
            <h3 className="text-foreground mb-2">{title}</h3>
            {description && (
                <p className="text-sm text-muted-foreground text-center">{description}</p>
            )}
        </div>
    );
}
